/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import { FC } from 'react'
import { toAbsoluteUrl } from '../../../../../../_metronic/helpers'
import { Bundle } from '../../core/_models'

type Props = {
  bundle: Bundle
}

const BundleInfoCell: FC<Props> = ({ bundle }) =>{
  return(
    <div className='d-flex align-items-center'>
      {/* begin:: Avatar */}
      <div className=' me-3'>
        <a href='#'>
          {bundle.service?.company?.company_logo ? (
            <div className='symbol-label'>
              <img src={`${bundle.service?.company?.company_logo}`} alt={bundle.bundle_name} className='w-25' />
            </div>
          ) : (
            <div
              className={clsx(
                'symbol-label fs-3',
                `bg-light-${bundle.bundle_name}`,
                `text-${bundle.bundle_name}`
              )}
            >
            </div>
          )}
        </a>
      </div>
      <div className='d-flex flex-column'>
        {/* <a href='#' className='text-gray-800 text-hover-primary mb-1'>
          {bundle.service?.company?.company_name}
        </a> */}
        <span>{bundle.service?.company?.company_name}</span>
      </div>
    </div>
  )
}

export { BundleInfoCell }
